import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const SalesReturn = () => {
  return (
    <PrintPreferenceTabs type="sales_return"></PrintPreferenceTabs>
  );
};
export default SalesReturn;


